var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgImageTypeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.927,
    height: 28.945,
    viewBox: "0 0 32.927 28.945",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "image",
    d: "M194.19,191.01H168.465a3.351,3.351,0,0,0-3.351,3.351V216.1a3.36,3.36,0,0,0,3.351,3.351H194.19a3.351,3.351,0,0,0,3.351-3.351V194.361a3.351,3.351,0,0,0-3.351-3.351Zm-28.508,3.351a2.782,2.782,0,0,1,2.782-2.782H194.19a2.782,2.782,0,0,1,2.782,2.782v13.085l-7.629-7.652a.273.273,0,0,0-.4,0l-8.829,8.818-2.082-2.076h0a.273.273,0,0,0-.4,0l-11.321,11.315a2.77,2.77,0,0,1-.632-1.746Zm1.036,23.894,11.116-11.116,11.742,11.748H168.465a2.77,2.77,0,0,1-1.747-.632Zm27.472.631h-3.806l-9.865-9.87,8.625-8.619,7.828,7.828V216.1a2.782,2.782,0,0,1-2.782,2.782Z",
    transform: "translate(-164.864 -190.76)",
    fill: "#404040",
    stroke: "#404040",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageTypeIcon);
export default __webpack_public_path__ + "static/media/imageTypeIcon.4d29d2b721c546d32de023020316dbd1.svg";
export { ForwardRef as ReactComponent };